import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { baseButtonStyle } from "@/components/editor/themes/crosby/constants";

export const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: 0 ${rem(40)};
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  .button-primitive {
    ${baseButtonStyle}
    margin: ${rem(8)} auto 0;
  }

  .image-primitive {
    border-radius: ${rem(20)};
    max-width: ${rem(496)};
    width: 100%;
    margin: auto;
  }

  ${(props) => props.$viewport.tablet`
    .image-primitive {
      max-width: ${rem(366)};
    }
  `};

  ${(props) =>
    props.$viewport.mobile`
      padding: 0;

      .button-primitive {
        width: 100%;
        margin-top: ${rem(16)};
      }
  `}
`;
